import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchInfluencerFollowerAnalysisQuery } from '@/api/influencer-api'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useFetchKolFollowerAnalysisQuery } from '@/api/workspace-api/kol-api'
import { usePermissions } from '@/hooks/use-permissions'
import { FollowerAnalyze } from '@/store/kol-detail'

type UseFollowerAnalyzeProps = (params: {
  kolId?: string
  kolDcIdHashed?: string
  isKolInfoLocked: boolean
  isFetchingKolInfo: boolean
}) => {
  followerAnalyze?: FollowerAnalyze
  isFetching: boolean
}
const useFollowerAnalyze: UseFollowerAnalyzeProps = ({
  kolId,
  kolDcIdHashed,
  isKolInfoLocked,
  isFetchingKolInfo,
}) => {
  const { withKolPermission } = usePermissions()
  const { data: userStatus } = useFetchUserStatusQuery(
    withKolPermission ? skipToken : undefined,
  )

  const {
    data: followerAnalyzeByAd,
    isFetching: isFetchingFollowerAnalyzeByAd,
  } = useFetchKolFollowerAnalysisQuery(
    !withKolPermission &&
      userStatus?.currentWorkspaceId &&
      kolId &&
      !isKolInfoLocked
      ? {
          workspaceId: userStatus.currentWorkspaceId,
          radar_uuid: kolId,
          dc_id_hashed: kolDcIdHashed,
        }
      : skipToken,
  )
  const {
    data: followerAnalyzeByKol,
    isFetching: isFetchingFollowerAnalyzeByKol,
  } = useFetchInfluencerFollowerAnalysisQuery(
    withKolPermission && kolId ? kolId : skipToken,
  )

  const followerAnalyze = !withKolPermission
    ? followerAnalyzeByAd
    : followerAnalyzeByKol

  const isFetching =
    isFetchingKolInfo ||
    isFetchingFollowerAnalyzeByAd ||
    isFetchingFollowerAnalyzeByKol

  return { followerAnalyze, isFetching }
}

export default useFollowerAnalyze
